<template>
    <div>
        <div name="query-sort-block">
            <swb-query-sort-area ref="query_model_ctrl" :queryOnLoad="true" :confKey="confKey" :configAuto="configAuto" :queryHandler="queryHandler"></swb-query-sort-area>
        </div>
        <div class="simple-row" v-if="checkActionPerm('create')">
            <div class="left">
                <button class="swb-btn swb-btn-small" @click="saveComRoleDlg(true)">新增职责权限</button>
                <span class="font-blue">新增后请填写pc功能和操作权限</span>
            </div>
        </div>

        <swb-result-table name="result_table" ref="result_table" :btnColBaseCount="2" :btnColMoreTitle="'更多操作'" :confKey="confKey" :configAuto="configAuto" :needPager="needPager" :multiSelect="multiSelect" :multiPageSelect="multiPageSelect"
                          :rowKeyPropName="rowKeyPropName" :rowNoShow="rowNoShow" :rowNoFixed="rowNoFixed" :btnColName="btnColName" :btnColTitle="btnColTitle" :btnColWidth="btnColWidth" :btnColFixed="btnColFixed" :height="tableHeight"
                          :pageNoChangeHandler="pageNoChangeHandler" :rowDblClickHandler="rowDblClickHandler"></swb-result-table>
    </div>
</template>

<script>
    import {Utils, $} from '../../app.base'
    import {Vue, MsgBox, DomSizeWatcher, Routes} from '../../app.vues'

    import {checkUserActionPerm} from '../index'
    import {getDefaultPageSizes} from '../../app.conf'
    import {openBizPermScopeDlg, openComRoleListSetDlg} from './selectDlg'

    import userApi from '../../api/user';
    import merchtAllApi from '../../api/merchtAll'

    import SwbMerchtTplRoleSave from './MerchtTplRoleSave';
    Vue.regist(SwbMerchtTplRoleSave);

    import SwbMerchtTplRoleRescList from './MerchtTplRoleRescList';
    Vue.regist(SwbMerchtTplRoleRescList);

    import SwbMobAppRoleSelect from './MobAppRoleSelect';
    Vue.regist(SwbMobAppRoleSelect);

    import SwbMerchtTplRoleRescForMobApp from './MerchtTplRoleRescForMobApp';
    Vue.regist(SwbMerchtTplRoleRescForMobApp);

    import SwbMerchtTplRoleDetail from './MerchtTplRoleDetail';
    Vue.regist(SwbMerchtTplRoleDetail);

    import SwbMerchtTplRoleBusinessSet from './MerchtTplRoleBusinessSet';
    Vue.regist(SwbMerchtTplRoleBusinessSet);

    import SwbResultColConf from '../query/ResultColConf.vue';
    import SwbResultTable from '../query/ResultTable.vue';
    Vue.regist(SwbResultColConf);
    Vue.regist(SwbResultTable);

    import SwbQuerySortArea from '../query/QuerySortArea';
    Vue.regist(SwbQuerySortArea);

    import SwbSaveComRoleBatch from './SaveComRoleBatch';
    Vue.regist(SwbSaveComRoleBatch);

    export default {
        name: 'swb-mercht-tpl-role-list',
        path: '/mercht/tpl/role/list',
        desc: '模板岗位管理',
        data: function () {
            return {
                confKey: 'swb-mercht-tpl-role-list',
                configAuto: true,
                tableHeight: '300',
                needPager: true, //是否需要分页（默认：true）
                multiSelect: false, //是否多选（默认：false）
                multiPageSelect: false, //是否要多页/跨页选择（默认：false）
                rowKeyPropName: "id", //记录数据关键标识列名（多页/跨页选择必须，默认: id）
                rowNoShow: false, //是否显示行号（默认：true）
                rowNoFixed: false, //行号列是否固定（默认：false）
                btnColName: 'actions',//操作列名称（如果不设置就不显示操作列）
                //
                btnColTitle: '操作',//操作列标题（默认：'操作'）
                btnColWidth: 300,//操作列宽度（默认：100）
                //
                btnColFixed: true, //操作列是否固定
                // 分页信息
                pageNumber: 1,
                totalCount: 0,
                pageSize: null,
                pageSizes: getDefaultPageSizes(),
                // 过滤信息
                queryKey: null,
                queryModel: {
                    filterItems: {},
                    sortItemList: [],
                    sortItems: {}
                },
                bizPermOrgFlagEnumMap: {},
                //
                scopeEntity: null
            }
        },
        created: function () {
            this.pageSize = this.pageSizes.first();
            this.bizPermOrgFlagEnumMap = getEnumMap("bizPermOrgFlag", "value2text");
            this.getCurrUserInfo();
        },
        mounted() {
            let self = this;
            //注册domSizeWatcher
            let thisEl = $(this.$el);
            $(this.$el).addClass("overflow-hidden");
            //
            let domSizeWatcher = this.domSizeWatcher = new DomSizeWatcher(Vue.$getClassInfo(this).name);
            domSizeWatcher.setBaseEl(thisEl);
            domSizeWatcher.setMainEl(thisEl.find('[name="result_table"]'), function (width, height, theEl) {
                //根据新主元素的内容大小，调整表格高度
                self.tableHeight = height;
            });
            //domSizeWatcher.setHrEls();
            console.log("domHeight： " + self.domHeight);
            domSizeWatcher.setVtEls(thisEl.find('[name="query-sort-block"], .simple-row, [name="change-actionName"]'));
            domSizeWatcher.start(500);
            //
            this.initResultTable();
        },
        destroyed() {
            //释放domSizeWatcher
            let domSizeWatcher = this.domSizeWatcher;
            if (domSizeWatcher != null) {
                domSizeWatcher.clear();
                this.domSizeWatcher = null;
            }
        },
        methods: {
            getCurrUserInfo(){
                let self = this;
                userApi.getUserInfoByContext({}, function (result) {
                    if (result.type == 'info') {
                        let scopeEntity = result.data.scopeEntity;
                        self.scopeEntity = scopeEntity;
                    }
                });
            },
            initResultTable(){
                let self = this;
                let query_model_ctrl = this.$refs['query_model_ctrl'];
                // let confColList = resultColConfCmp.getMetaColList();
                let resultTable = this.$refs['result_table'];
                //关联[列配置对象]到结果表格（结果表格可以实时利用最新的列配置，同时结果表格列宽也会反向同步到[列配置对象]中去）
                resultTable.setQrySortRef(query_model_ctrl);    // .getResultColConfRef()
                //
                resultTable.initMeta(/* confColList, */ /* 单元格html渲染函数 */{
                    'moveUpComRole': function (row, colName, colValue, rowIndex, colConf) {
                        let domHtml = '';
                        if (self.checkActionPerm('move')) {
                            domHtml = domHtml + '<a name="moveUp" class="icon iconfont icon-arrow-top swb-btn swb-btn-link"></a>';
                            domHtml = domHtml + '<a name="moveDow" class="icon iconfont icon-arrow-bottom swb-btn swb-btn-link"></a>';
                        }
                        return domHtml;
                    },
                    'comLevel': function (row, colName, colValue, rowIndex, colConf) {
                        let domHtml = "";
                        if (row.shopFlag) {
                            return domHtml;
                        }
                        if (row.comLevel1) {
                            domHtml = domHtml + '<span>' + "一级业务单元" + '</span>'
                        }
                        if (row.comLevel2) {
                            if (row.comLevel1) {
                                domHtml = domHtml + '<span>' + "，" + '</span>'
                            }
                            domHtml = domHtml + '<span>' + "二级业务单元" + '</span>'
                        }
                        if (row.comLevel3) {
                            if (row.comLevel1 || row.comLevel2) {
                                domHtml = domHtml + '<span>' + "，" + '</span>'
                            }
                            domHtml = domHtml + '<span>' + "三级业务单元" + '</span>'
                        }
                        if (row.comLevel4) {
                            if (row.comLevel1 || row.comLevel2 || row.comLevel3) {
                                domHtml = domHtml + '<span>' + "，" + '</span>'
                            }
                            domHtml = domHtml + '<span>' + "四级业务单元" + '</span>'
                        }
                        return domHtml;
                    },
                    'bizPermOrgFlag': function (row, colName, colValue, rowIndex, colConf) {
                        let bizPermOrgFlag = self.bizPermOrgFlagEnumMap[row.bizPermOrgFlag] || "";
                        //
                        return '<span>' + bizPermOrgFlag + '</span>';
                    },
                    'actions': function (row, colName, colValue, rowIndex) {
                        let btnList = [];
                        //
                        if (self.checkActionPerm('pc_resc')) {
                            btnList.push({
                                name: 'pc_resc',
                                text: 'PC功能'
                            });
                        }
                        if (self.checkActionPerm('pc_action')) {
                            btnList.push({
                                name: 'pc_action',
                                text: 'PC操作权限'
                            });
                        }
                        if (self.checkActionPerm('biz_scope') && row.bizPermFlag && row.bizPermScopId != -1) {
                            btnList.push({
                                name: 'biz_scope',
                                text: '业务范围'
                            })
                        }
                        if (self.checkActionPerm('modify') && row.createMerchantId == self.scopeEntity.id) {
                            btnList.push({
                                name: 'modify',
                                text: '编辑'
                            })
                        }
                        if (self.checkActionPerm('mob_resc')) {
                            btnList.push({
                                name: 'mob_resc',
                                text: '移动功能'
                            });
                        }
                        if (self.checkActionPerm('rel_com_role')) {
                            btnList.push({
                                name: 'rel_com_role',
                                text: '关联岗位'
                            })
                        }
                        if (self.checkActionPerm('view')) {
                            btnList.push({
                                name: 'view',
                                text: '查看已关联岗位'
                            });
                        }
                        if (self.checkActionPerm('delete') && row.createMerchantId == self.scopeEntity.id && !row.bizRefFlag) {
                            btnList.push({
                                name: 'delete',
                                text: '删除'
                            });
                        }
                        if (self.checkActionPerm('copy')) {
                            btnList.push({
                                name: 'copy',
                                text: '复制'
                            });
                        }
                        if (self.checkActionPerm('add_role')) {
                            btnList.push({
                                name: 'add_role',
                                text: '批量创建岗位'
                            });
                        }
                        return btnList;
                    }
                }, /* 单元格按钮点击处理函数 */{
                    'moveUpComRole': function (row, colName, colValue, rowIndex, btnName) {
                        if (btnName == 'moveUp') {
                            self.moveUpComRole(row.id, true);
                        } else {
                            self.moveUpComRole(row.id, false);
                        }
                    },
                    'actions': function (row, colName, colValue, rowIndex, btnName) {
                        if (btnName == 'pc_resc') {
                            self.showRoleRescDlg(row);
                        } else if (btnName == 'pc_action') {
                            self.showBusinessSetDlg(row);
                        } else if (btnName == 'mob_resc') {
                            self.appResc(row);
                        } else if (btnName == 'rel_com_role') {
                            // 关联岗位
                            self.doRelComRole(row);
                        } else if (btnName == 'view') {
                            self.view(row);
                        } else if (btnName == "delete") {
                            self.deleteMerchtTplRole(row.id);
                        } else if (btnName == "modify") {
                            self.saveComRoleDlg(false, row);
                        } else if (btnName == "biz_scope") {
                            self.showBizScopeDlg(row);
                        } else if (btnName == "copy") {
                            self.doCopy(row);
                        } else if (btnName == "add_role") {
                            self.showAddRoleDlg(row);
                        }
                    }
                });
            },
            renderTable(rows, pagination) {
                let resultTable = this.$refs.result_table;
                //清除数据（如果已经渲染的数据与新的列不是一回事儿）
                //resultTable.clear();
                //同步使用新的自定义列信息
                //resultTable.initMeta(confColList);
                //设置新数据
                let tableData = {
                    rows: rows,
                    pagination: pagination
                };
                resultTable.render(tableData);
            },
            // 单元格点击事件
            rowDblClickHandler: function (row) {
                if (!this.multiSelect) {
                    console.log("----- 双击数据行 ----");
                    console.log(row);
                }
            },
            //
            checkActionPerm: function (action) {
                return checkUserActionPerm(Vue.$getClassInfo(this).path, action, null);
            },
            handleSizeChange: function (val) {
                this.pageSize = val;
                this.handlePageChange(1);
            },
            handlePageChange: function (val) {
                this.pageNumber = val;
                this.getDataList();
            },
            queryHandler: function (queryModel) {
                this.queryModel = queryModel;
                this.pageNumber = 1;
                this.getDataList();
            },
            pageNoChangeHandler: function (pageNumber, pageSize) {
                console.log("分页 => 第【" + pageNumber + "】页，大小：" + pageSize);
                //
                this.pageSize = pageSize;
                this.pageNumber = pageNumber;
                //
                this.getDataList();
            },
            getDataList(){
                let self = this;
                let postData = {};
                postData.pagination = {
                    pageSize: self.pageSize,
                    pageNumber: self.pageNumber,
                };
                //
                let queryModel = self.queryModel;
                let filterItems = Utils.merge({}, queryModel.filterItems);
                let sortItemList = Utils.merge([], queryModel.sortItemList);
                let sortItems = Utils.merge({}, queryModel.sortItems);
                //
                postData.filterItems = filterItems;
                postData.sortItemList = sortItemList;
                postData.sortItems = sortItems;
                //
                let theLoading = MsgBox.loading();
                // 调用查询接口
                merchtAllApi.getMerchtTplRoleList(postData, function (result) {
                    theLoading.close();
                    if (result.type == 'info') {
                        let dataList = result.data.rows || [];
                        //
                        let pagination = result.data.pagination;
                        self.totalCount = pagination.totalCount;
                        self.renderTable(dataList, pagination);
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            saveComRoleDlg(isAdd, row){
                isAdd = Utils.isTrue(isAdd);
                let title = isAdd ? "职责权限 - 添加" : "职责权限 - 更新";
                let roleInfo = Utils.merge({}, row);
                let self = this;
                let theDlg = Vue.$showDialog({
                    title: title,
                    width: 700,
                    height: 600,
                    showCloseBtn: true,
                    template: '<div>' +
                    '<swb-mercht-tpl-role-save :item="roleInfo" :isAdd="isAdd" ref="swb_mercht_tpl_role_save"></swb-mercht-tpl-role-save>' +
                    '</div>',
                    data: {
                        roleInfo: roleInfo,
                        isAdd: isAdd
                    },
                    okClicked: function () {
                        let result = this.$refs.swb_mercht_tpl_role_save.getDlgResult() || {};
                        if (result.type == 'info') {
                            // 处理你的信息添加赋值
                            let tplComRole = result.data;
                            if (isAdd) {
                                let theLoading = MsgBox.loading();
                                merchtAllApi.saveMerchtTplRole(tplComRole, function (result) {
                                    theLoading.close();
                                    if (result.type == 'info') {
                                        theDlg.close();
                                        self.$message.success("操作成功");
                                        self.getDataList();
                                    } else {
                                        MsgBox.warning(result.message);
                                    }
                                });
                            } else {
                                let theLoading = MsgBox.loading();
                                merchtAllApi.updateMerchtTplRole(tplComRole, function (result) {
                                    theLoading.close();
                                    if (result.type == 'info') {
                                        theDlg.close();
                                        self.$message.success("操作成功");
                                        self.getDataList();
                                    } else {
                                        MsgBox.warning(result.message);
                                    }
                                });
                            }
                        }
                        return false;
                    }
                });
            },
            moveUpComRole: function (id, toUp) {
                var self = this;
                let data = {};
                data.id = id;
                data.toUp = toUp;
                merchtAllApi.doMerchtTplRoleMove(data, function (result) {
                    if (result.type == "info") {
                        self.$message.success("操作成功");
                        self.getDataList();
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            // 删除
            deleteMerchtTplRole: function (id) {
                let self = this;
                this.$confirm("确定要删除吗", '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(function () {
                    let theLoading = MsgBox.loading();
                    let postData = {
                        id: id
                    };
                    merchtAllApi.deleteMerchtTplRole(postData, function (result) {
                        theLoading.close();
                        if (result.type === "info") {
                            MsgBox.success("操作成功");
                            self.getDataList();
                        } else {
                            MsgBox.warning(result.message);
                        }
                    });
                }).catch(function () {
                });
            },
            //
            showRoleRescDlg(row){
                let self = this;
                let theDlg = Vue.$showDialog({
                    title: "岗位资源（备注：斜体、字体颜色浅的为功能资源，不是菜单！！！）",
                    width: 900,
                    height: 700,
                    showCloseBtn: true,
                    template: '<div>' +
                    '<swb-mercht-tpl-role-resc-list :readOnly="readOnly" :roleId="roleId" ref="swb_mercht_tpl_role_resc_list"></swb-mercht-tpl-role-resc-list>' +
                    '</div>',
                    data: {
                        roleId: row.id,
                        readOnly: row.createMerchantId != self.scopeEntity.id
                    },
                    okClicked: function () {
                        let result = this.$refs.swb_mercht_tpl_role_resc_list.getDlgResult() || {};
                        if (result.type == 'info') {
                            let data = result.data;
                            let postData = {};
                            postData.roleId = row.id;
                            postData.rescIds = data;
                            let theLoading = MsgBox.loading();
                            merchtAllApi.saveMerchtTplRoleRescs(postData, function (result) {
                                theLoading.close();
                                if (result.type == 'info') {
                                    theDlg.close();
                                    self.$message.success("操作成功");
                                    self.getDataList();
                                } else {
                                    MsgBox.warning(result.message);
                                }
                            });
                        }
                        return false;
                    }
                });
            },
            showBusinessSetDlg(row){
                let self = this;
                let theDlg = Vue.$showDialog({
                    title: "业务 - 设置",
                    width: 900,
                    height: 700,
                    showCloseBtn: false,
                    okVisible: false,
                    cancelText: "关闭",
                    template: '<div>' +
                    '<swb-mercht-tpl-role-business-set :readOnly="readOnly" :bizUnitLevel="bizUnitLevel" :roleId="roleId" :bizPermFlag="bizPermFlag" ref="swb_mercht_tpl_role_business_set"></swb-mercht-tpl-role-business-set>' +
                    '</div>',
                    data: {
                        roleId: row.id,
                        bizPermFlag: row.bizPermFlag,
                        bizUnitLevel: row.comLevel,
                        readOnly: row.createMerchantId != self.scopeEntity.id
                    },
                    cancelClicked(){
                        self.getDataList();
                    }
                });
            },
            appResc(row){
                let self = this;
                let shopFlag = true;
                if (this.activeName == 'com') {
                    shopFlag = false;
                }
                let theDlg = Vue.$showDialog({
                    title: '移动端资源',
                    width: 900,
                    height: 700,
                    showCloseBtn: true,
                    okVisible: true,
                    cancelText: "取消",
                    template: '<div class = "">' +
                    '<swb-mercht-tpl-role-resc-for-mob-app :readOnly="readOnly" :roleId="roleId" @handle-change="handleChange" ref="swb_mob_app_role_resc"></swb-mercht-tpl-role-resc-for-mob-app>' +
                    '</div>',
                    data: {
                        roleId: row.id,
                        readOnly: row.createMerchantId != self.scopeEntity.id
                    },
                    okClicked: function () {
                        let selfDlg = this;
                        let result = this.$refs.swb_mob_app_role_resc.getDlgResult() || {};
                        if (result.type == 'info') {
                            let theLoading = MsgBox.loading();
                            merchtAllApi.saveMobAppRoleRescAndAction(result.data, function (resultData) {
                                theLoading.close();
                                if (resultData.type == 'info') {
                                    selfDlg.$message.success("保存成功");
                                    self.getDataList();
                                } else {
                                    MsgBox.warning(resultData.message);
                                }
                            });
                        } else {
                            MsgBox.warning(result.message);
                        }
                        return false;
                    },
                    methods: {
                        handleChange: function () {
                            self.getDataList();
                            theDlg.close();
                        },
                    },
                });
            },
            // 关联岗位
            doRelComRole: function (row) {
                let self = this;
                let params = {
                    tplRoleId: row.id
                };
                openComRoleListSetDlg(params, function (comRoleIds, theDlg) {
                    let postData = {
                        tplRoleId: row.id,
                        comRoleIds: comRoleIds
                    };
                    let theLoading = MsgBox.loading();
                    merchtAllApi.doMerchtTplRoleRelComRole(postData, function (resultData) {
                        theLoading.close();
                        if (resultData.type == 'info') {
                            theDlg.close();
                            MsgBox.success("关联成功");
                            self.getDataList();
                        } else {
                            MsgBox.warning(resultData.message);
                        }
                    });
                });
            },
            view(row){
                let self = this;
                Vue.$showDialog({
                    title: "职责权限关联详情",
                    width: 1300,
                    height: 800,
                    okVisible: false,
                    showCloseBtn: true,
                    cancelText: '关闭',
                    template: '<div>' +
                    '<swb-mercht-tpl-role-detail :tplId="tplId" :tplRole="tplRole" :parentPath="parentPath"></swb-mercht-tpl-role-detail>' +
                    '</div>',
                    data: {
                        tplId: row.id,
                        tplRole: row,
                        parentPath: Vue.$getClassInfo(self).path
                    },
                    methods: {},
                });
            },
            showBizScopeDlg(row){
                openBizPermScopeDlg(row.bizPermScopId, true, function () {

                });
            },
            doCopy(row){
                let self = this;
                let theDlg = Vue.$showDialog({
                    title: "复制职责权限",
                    width: 580,
                    height: 400,
                    showCloseBtn: true,
                    template: '<div class="simple-form">' +
                    '<div class="form-group center">' +
                    '   <div class="form-label">' +
                    '       <label>职责权限名称</label>' +
                    '   </div>' +
                    '   <div class="form-value width-2x">' +
                    '       <span>{{ row.confName }}</span>' +
                    '   </div>' +
                    '</div>' +
                    '<div class="form-group center">' +
                    '   <div class="form-label">' +
                    '       <label class="required">新职责权限名称</label>' +
                    '   </div>' +
                    '   <div class="form-value width-2x">' +
                    '       <el-input v-model="newConfName"></el-input>' +
                    '   </div>' +
                    '</div>' +
                    '</div>',
                    data: {
                        row: row,
                        newConfName: row.confName + '-副本'
                    },
                    okClicked: function () {
                        let newConfName = this.newConfName;
                        if (Utils.isNoB(newConfName) || newConfName.trim().length == 0) {
                            this.$message.warning('新职责权限名称不可为空');
                            return false;
                        }
                        newConfName = newConfName.trim();
                        if (newConfName.length > 60) {
                            this.$message.warning('新职责权限名称最长60');
                            return false;
                        }
                        // 调用复制接口
                        let postData = {};
                        postData.id = row.id;
                        postData.confName = this.newConfName;
                        let theLoading = MsgBox.loading();
                        merchtAllApi.doMerchtTplRoleCopy(postData, function (result) {
                            theLoading.close();
                            if (result.type == 'info') {
                                theDlg.close();
                                self.$message.success("操作成功");
                                self.getDataList();
                            } else {
                                MsgBox.warning(result.message);
                            }
                        });
                        return false
                    },
                    methods: {}
                });
            },
            showAddRoleDlg(row){
                Vue.$showDialog({
                    title: "批量创建岗位",
                    width: 1300,
                    height: 800,
                    okVisible: false,
                    showCloseBtn: true,
                    cancelText: '关闭',
                    template: '<swb-save-com-role-batch :tplRole="tplRole"></swb-save-com-role-batch>',
                    data: {
                        tplRole: row
                    },
                    methods: {},
                });
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/authx/MerchtTplRoleList.vue